import data from './timezones.json' with { type: 'json' };
// Annotated rather than inferred, so the declaration carries the shape of one
// entry instead of the literal type of all 107.
export const timezones = data;
export function getDefaultTimezone() {
    const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (currentTimezone) {
        const matchingTimezone = timezones.find((timezone) => timezone.utc.includes(currentTimezone));
        if (matchingTimezone) {
            return matchingTimezone.utc[0];
        }
    }
    return '';
}
//# sourceMappingURL=index.js.map